<template>
  <div class="box" style="margin-top:0.2rem">
    <van-tabs v-model="active" line-height="0" class="tabs_">
      <van-tab v-for="(item,i) in content" :key="item.id" class="tab_">
        <template slot="title">
          <div class="tagname">{{item.tagname}}</div>
          <div :class="active==i ? 'sname-change flex-center':'sname'">{{item.sname}}</div>
        </template>
        <!-- <div v-for="(goods,i) in item.list"> -->
        <goodsItem1 :goodsList="item.list"></goodsItem1>
        <!-- </div> -->
      </van-tab>
    </van-tabs>
  </div>
</template>

<style scoped>
  .box >>> .van-tabs__line {
    background-color: none !important;
  }

  .box >>> .van-tabs__nav {
    background: none;
  }

  .box >>> .van-hairline--top-bottom::after, .box >>> .van-hairline-unset--top-bottom::after {
    border: none !important;
  }

  .van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after {
    border: none !important;
  }

  .tagname {
    height: 16px;
    font-size: 16px;
    font-weight: 800;
    color: rgba(51, 51, 51, 1);
    line-height: 16px;
    text-align: center;
  }

  .sname-change {
    height: 22px;
    background: rgba(250, 74, 85, 1);
    border-radius: 10px;
    color: #fff;
    margin-top: 4px;
    /*line-height: 22px;*/
    padding: 0 5px;
    text-align: center;
  }

  .sname {
    height: 22px;
    border-radius: 10px;
    color: #999999;
    margin-top: 4px;
    line-height: 22px;
    padding: 0 5px;
    text-align: center;
  }
</style>

<script>
    import Vue from 'vue';
    import {Tab, Tabs} from 'vant';
    import goodsItem1 from '@/components/index/GoodsItem1.vue';

    Vue.use(Tab).use(Tabs);
    export default {
        name: "GoodsTabs",
        components: {
            goodsItem1
        },
        props: {
            content: {
                type: Array,
                default: [],
            },

        },

        data: function () {
            return {
                active: 0
            }
        },
        methods: {
            onTabsClick(item, i) {
                console.log(item, i)
            }
        },

        filters: {}

    };
</script>




// WEBPACK FOOTER //
// GoodsTabs.vue?905d3d7a